<template>
  <InViewport @enter="onInViewport">
    <div class="gmf-upload-grid-wrapper gmf-context" style="container-type: inline-size;">
      <div class="gmf-upload-grid-image-wrapper">
        <button class="gmf-upload-grid-image gmf-upload-grid-more" @click.stop="() => openSocialModal({ filter: { 'has_images': 1 } })">
          <div class="gmf-upload-grid-more-text">{{ t('show_more') }}</div>
          <Icon icon="upload-grid-show-more" />
        </button>
      </div>
      <div class="gmf-upload-grid-image-wrapper" v-for="(comment, index) in comments" :key="comment.id" :style="{ 'order': index }">
        <CustomerImage
          :comment="comment"
          class="gmf-upload-grid-image"
        />
     </div>
      <div class="gmf-upload-grid-image-wrapper" v-for="i in 9 - comments.length" :key="i" :style="{ 'order': i-1 }">
        <div class="gmf-upload-grid-image gmf-upload-grid-more gmf-upload-grid-more-placeholder">
        </div>
     </div>
    </div>
  </InViewport>
</template>

<style>
.gmf-upload-grid-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: calc(var(--gmf-object-spacing) / 8 * -1);
}
.gmf-upload-grid-image-wrapper {
  padding: calc(var(--gmf-object-spacing) / 8);
  max-width: calc(100% / 5);
}
.gmf-upload-grid-image-wrapper:has(.gmf-upload-grid-more) {
  order: 5;
}
.gmf-upload-grid-more {
  cursor: pointer;
  background: var(--gmf-brand-color);
  color: var(--gmf-col-white) !important;
  padding: var(--gmf-p-4);
  display: flex;
  flex-direction: column;
  justify-content: flex-end !important;
  align-items: flex-start !important;
  height: 100%;
  border: 0;
  margin: 0;
}
.gmf-upload-grid-more-placeholder {
  background: var(--gmf-col-gray) !important;
  cursor: default !important;
}
.gmf-upload-grid-more .gmf-icon {
  width: 40px;
  height: 40px;
  --gmf-icon-color: var(--gmf-col-white);
}
.gmf-upload-grid-more-text {
  text-align: left;
  color: var(--gmf-col-white) !important;
  font-size: 20px !important;
  font-weight: var(--gmf-default-font-weight) !important;
  max-width: 175px;
  margin-left: 5px;
}
.gmf-upload-grid-more > *{
  transition: transform 0.4s ease;
}
.gmf-upload-grid-more:hover > *,
.gmf-upload-grid-more:focus > * {
  transform: translateX(8px);
}

.gmf-upload-grid-image {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  aspect-ratio: 0.85;
  object-fit: cover;

  transition: 0.2s linear filter;
}

.gmf-upload-grid-image-wrapper {
  width: 100%;
  cursor: pointer;
}

@container (max-width: 1000px) and (min-width: 768px) {
  .gmf-upload-grid-image-wrapper {
    max-width: calc(100% / 3);
  }
  .gmf-upload-grid-image-wrapper:nth-child(10) {
    display: none;
  }
  .gmf-upload-grid-image-wrapper:has(.gmf-upload-grid-more) {
    order: 6;
  }
}

@container (max-width: 768px) {
  .gmf-upload-grid-image-wrapper {
    max-width: calc(100% / 2);
  }
  .gmf-upload-grid-image-wrapper:nth-child(1n+7) {
    display: none;
  }
  .gmf-upload-grid-image-wrapper:has(.gmf-upload-grid-more) {
    order: 4;
  }
}
</style>

<script>
import state from '@/state';
import callApi from '@/utils/callApi';

import Icon from '@/components/Icon';
import InViewport from '@/components/InViewport';
import CustomerImage from '@/components/CustomerImage';
import openSocialModal from '../SocialFeed/openSocialModal';

const t = state.t.prefix('upload_grid');

export default {
  name: 'UserUploadsGrid',
  components: {
    Icon,
    InViewport,
    CustomerImage,
  },
  data() {
    return {
      comments: [],
    };
  },
  computed: {
    allowedGuests() {
      let config = state.merchantConfig.comments;
      let allowSocialPost = config.social_post.enabled && config.social_post.allowGuests;
      return allowSocialPost;
    },
  },
  methods: {
    t,
    openSocialModal,
    onInViewport(inViewport) {
      if (inViewport) {
        this.loadComments();
      }
    },
    async loadComments() {
      const query = new URLSearchParams({
        'take': 9,
        'order': 'hot',
        'has_images': 1,
        'reply_depth': 0,
        'no_count': 1,
      });

      const res = await callApi('GET', state.commentSearchEndpoint + '?' + query.toString());
      const { comments } = await res.json();

      this.comments = comments.sort(() => 0.5 - Math.random()); // Randomize order
    }
  },
};
</script>